<template>
  <div class="swiper-tab">
    <div
      v-if="list.length"
      v-swiper-products-listings
      class="swiper-container swiper-container--product-same-category">
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div
          class="swiper-slide"
          v-for="(slide, index) of list"
          :key="index">
          <router-link :to="{ name: 'single-product', params: { slug: slide.fields.slug } }">
            <img
              v-if="typeof slide.fields.mainPicture !== 'undefined'"
              :data-srcset="`${slide.fields.mainPicture.fields.file.url}?w=250&fit=scale 1x, ${slide.fields.mainPicture.fields.file.url}?w=500&fit=scale 2x`"
              v-lazy="`${slide.fields.mainPicture.fields.file.url}?w=250&fit=scale`"
              :alt="slide.fields.mainPicture.fields.description"
              :width="250"
              class="swiper-container--product-same-category__img">
            <p v-html="slide.fields.title"/>
            <span v-if="typeof slide.fields.listingFeatures !== 'undefined'" v-html="slide.fields.listingFeatures" />
            <SingleProductListHasTags :product="slide" />
          </router-link>
        </div>
        <!-- Fine Slides -->
      </div>
      <!-- Operations -->
      <div class="swiper-operations">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import swiper from './swiper'
import SingleProductListHasTags from '@/components/SingleProductListHasTags/SingleProductListHasTags.vue'

export default {
  name: 'SwiperTab',
  components: {
    SingleProductListHasTags
  },
  mixins: [swiper],
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/tag-category-product.png')
  }),
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
